module.exports = __webpack_public_path__ + "static/media/Inception5.fa4d5b93.gif";